import React, { useEffect, useState, useRef } from "react";
import {LOCALE_ES_GRID} from "../../../Commons/Scripts/Utils";
import {
    AutoComplete,
    SelectButton,
    Dropdown,
    addLocale,
    Button,
    Column,
    DataTable,
    Calendar,
    ProgressSpinner,
    FilterMatchMode,
    FilterOperator,
    InputNumber,
    locale,
    Message
} from 'primereact';
import {
    exportarRentabilidadGrid,
    exportarTiendasGrid,
    useBuscarItemsAutoComplete,
    useBuscarRentabilidadPorItemdGrid
} from "../Services/facturacion-service";
import useExceptionHandler from "../../../Commons/Scripts/Hooks/useExceptionHandler";
import {createPortal} from "react-dom";
import Exportar from "../../../Commons/Scripts/Componentes/Exportar/Exportar";
import ToolTip from "../../../Commons/Scripts/Componentes/ToolTip/Tooltip";
import {SvgComponent} from "../../../Commons/Scripts/Componentes";
import { Dropdown as Dp, Nav } from 'react-bootstrap';
import {useTheme} from "../../../Commons/Scripts/Hooks";
export const RentabilidadPorItemGrid = () => {
    addLocale("es", LOCALE_ES_GRID);
    const {handleException} = useExceptionHandler();
    const {theme} = useTheme();
    const [showExportar, setShowExportar] = useState(false);
    const monedaPredeterminada = window.monedaPredeterminada;
    const [fechasGrid, setFechasGrid] = useState(null);
    const [items, setItems] = useState([]);
    const [periodoGrid, setPeriodoGrid] = useState("mensual");
    const [filtros, setFiltros] = useState(null);
    const [cargandoData, setCargandoGrid] = useState(true);
    const [gridWhere, setGridWhere] = useState({
        where: {
            EsAscendente: false,
            EsOrdernable: true,
            OrderBy: "VentaTotalPeriodoActual",
            IndiceDePagina: 0,
            esFecha: false,
            periodo: periodoGrid,
            ItemsNombresList: items,
        },
    });
    const { data: itemsGrid, error: errorItemsGrid } = useBuscarRentabilidadPorItemdGrid(gridWhere);
    const [totalRecords, setTotalRecords] = useState(0);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: "VentaTotalPeriodoActual",
        sortOrder: -1,
        filters: {
            VentaTotalPeriodoActual: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            Costo: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            Ganancias: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaPromedioMargenGanancia: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaCrecimientoVenta: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            PromedioVenta: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            PosiblesVentas: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaRelacionCotizacionFactura: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            ItemNombre: {
                value: null,
                matchMode: FilterMatchMode.IN,
            },
        },
    });
    
    const onPage = (event) => {
        const newWhere = {
            where: {
                ...gridWhere.where,
                fechaInicio: fechasGrid?.[0] ?? null,
                fechaFin: fechasGrid?.[1] ?? null,
                IndiceDePagina: event.page,
            },
        };
        setGridWhere(newWhere);
        setlazyState(event);
        setCargandoGrid(true);
    };
    const onSort = (event) => {
        const newWhere = {
            where: {
                ...gridWhere.where,
                fechaInicio: fechasGrid?.[0] ?? null,
                fechaFin: fechasGrid?.[1] ?? null,
                EsAscendente: event.sortOrder === 1,
                OrderBy: event.sortField,
            },
        };
        setGridWhere(newWhere);
        setlazyState(event);
        setCargandoGrid(true);
    };
    const onFilter = (event) => {
        const filtros = event.filters;
        setlazyState(event);
        const newWhere = {
            where: {
                ...gridWhere.where,
                fechaInicio: fechasGrid?.[0] ?? null,
                fechaFin: fechasGrid?.[1] ?? null,
                ItemNombreList: filtros.ItemNombre.value,
                VentaTotalPeriodoActualFiltros: filtros.VentaTotalPeriodoActual.constraints.map((e) => ({
                    [e.value]: e.matchMode,
                })),
                CostoFiltros: filtros.Costo.constraints.map((e) => ({
                    [e.value]: e.matchMode,
                })),
                GananciasFiltros: filtros.Ganancias.constraints.map((e) => ({
                    [e.value]: e.matchMode,
                })),
                TasaPromedioMargenGananciaFiltros: filtros.TasaPromedioMargenGanancia.constraints.map(
                    (e) => ({ [e.value]: e.matchMode })
                ),
                TasaCrecimientoVentaFiltros: filtros.TasaCrecimientoVenta.constraints.map(
                    (e) => ({ [e.value]: e.matchMode })
                ),
                PromedioVentaFiltros: filtros.PromedioVenta.constraints.map(
                    (e) => ({ [e.value]: e.matchMode })
                ),
                PosiblesVentasFiltros: filtros.PosiblesVentas.constraints.map((e) => ({
                    [e.value]: e.matchMode,
                })),
                TasaRelacionCotizacionFacturaFiltros:
                    filtros.TasaRelacionCotizacionFactura.constraints.map((e) => ({
                        [e.value]: e.matchMode,
                    })),
            },
        };
        setGridWhere(newWhere);
        setCargandoGrid(true);
    };
    const borrarFiltros = () => {
        const newWhere = {
            where: {
                ...gridWhere.where,
                fechaInicio: fechasGrid?.[0] ?? null,
                fechaFin: fechasGrid?.[1] ?? null,
                VentaTotalPeriodoActualFiltros: null,
                CostoFiltros: null,
                GananciasFiltros: null,
                TasaPromedioMargenGananciaFiltros: null,
                TasaCrecimientoVentaFiltros: null,
                PromedioVentaFiltros: null,
                PosiblesVentasFiltros: null,
                TasaRelacionCotizacionFacturaFiltros: null,
                ItemNombreList: null
            },
        };
        setGridWhere(newWhere);
        setCargandoGrid(true);
        initFiltros();
    };
    const initFiltros = () => {
        setFiltros({
            VentaTotalPeriodoActual: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            Costo: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            Ganancias: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaPromedioMargenGanancia: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaCrecimientoVenta: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            PromedioVenta: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            PosiblesVentas: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            TasaRelacionCotizacionFactura: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO }],
            },
            ItemNombre: {
                value: null,
                matchMode: FilterMatchMode.IN,
            },
        });
    };
    const formatearMoneda = (value) => {
        return `${monedaPredeterminada} ${Citrus.Convert.toCurrencyNoSimbolo(
            value
        )}`;
    };
    const formatearTasa = (value) => {
        return `${value.toFixed(2)}%`;
    };
    const montoFiltroTemplate = (options) => {
        return (
            <InputNumber
                value={options.value}
                onChange={(e) => options.filterCallback(e.value, options.index)}
                prefix={monedaPredeterminada}
                locale="en-US" minFractionDigits={2}
            />
        );
    };
    const tasasFiltroTemplate = (options) => {
        return (
            <InputNumber
                value={options.value}
                onChange={(e) => options.filterCallback(e.value, options.index)}
                suffix="%"
            />
        );
    };
    const NombreFiltroTemplate = (options) => {
        return (
            <AutoComplete
                pt={{
                    panel: { style: { width: "400px" } },
                }}
                onClick={(e) => autoCompleteRef.current.search(e, "", "dropdown")}
                ref={autoCompleteRef}
                emptyMessage="No hay resultados disponibles"
                showEmptyMessage="true"
                inputId="itemAutocomplete"
                value={options.value}
                multiple
                suggestions={dataFiltrada || []}
                completeMethod={buscarItems}
                placeholder="Buscar Items"
                onChange={(e) => options.filterCallback(e.value)}
                style={{ width: "400px" }}
            />
        );
    };

    //multiLookup
    const autoCompleteRef = useRef(null);
    const [where, setWhere] = useState({ where: {} });
    const { data } = useBuscarItemsAutoComplete(where);
    const [dataFiltrada, setDataFiltrada] = useState([]);
    const [cargando, setCargando] = useState(true);
    const buscarItems = (event) => {
        setWhere({ where: { Criterio: event.query, CantidadPorPagina: 1000 } });
    };
    
    //filtro periodos
    const [periodo, setPeriodo] = useState(1);
    const periodos = [
        { name: "Actual", value: 1 },
        { name: "Anterior", value: 2 },
        { name: "Otro", value: 3 },
    ];
    const [value, setValue] = useState(3);
    const [periodosPredifinidos, setPeriodosPredifinidos] = useState([]);
    const actual = [
        { name: "Hoy", value: 1 },
        { name: "Esta Semana", value: 2 },
        { name: "Este Mes", value: 3 },
        { name: "Este Trimestre", value: 4 },
        { name: "Este Año", value: 5 },
    ];
    const anterior = [
        { name: "Ayer", value: 6 },
        { name: "Semana Anterior", value: 7 },
        { name: "Mes Anterior", value: 8 },
        { name: "Trimestre Anterior", value: 9 },
        { name: "Año Anterior", value: 10 },
    ];
    function handleChange(value) {
        setValue(value);
        setCargandoGrid(true);
        let periodo;
        switch (value) {
            case 1:
                periodo = "diario";
                break;
            case 2:
                periodo = "semanal";
                break;
            case 3:
                periodo = "mensual";
                break;
            case 4:
                periodo = "trimestral";
                break;
            case 5:
                periodo = "anual";
                break;
            case 6:
                periodo = "ayer";
                break;
            case 7:
                periodo = "semana anterior";
                break;
            case 8:
                periodo = "mes anterior";
                break;
            case 9:
                periodo = "trimestre anterior";
                break;
            case 10:
                periodo = "ano anterior";
                break;
        }
        setPeriodoGrid(periodo);
        const newWhere = {
            where: {
                ...gridWhere.where,
                periodo: periodo,
                esFecha: false
            },
        };
        setGridWhere(newWhere);
    }
    const [dates, setDates] = useState(null);
    let today = new Date();
    const [verRangoDeFechas, setVerRangoDeFechas] = useState(false);
    
    function setFechas() {
        setValue(null)
        const fechasFormateadas = dates.map(date => formatDate(date));
        setFechasGrid(fechasFormateadas);
        const newWhere = {
            where: {
                ...gridWhere.where,
                fechaInicio: formatDate(dates[0]),
                fechaFin: formatDate(dates[1]),
                esFecha: true
            },
        };
        setGridWhere(newWhere);
        setCargandoGrid(true);
    }
    function formatDate(date) {
        var date = new Date(date);
        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        return day + "/" + month + "/" + year;
    }
    const header = () => {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div className='p-component'>
                    <Button
                        type="button"
                        icon="pi pi-filter-slash"
                        label="Limpiar Filtros"
                        outlined
                        onClick={borrarFiltros}
                        id="quitarFiltros"
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        flexDirection: "column",
                        alignItems: "center",
                        minWidth: "50%",
                    }}
                >
                    <div style={{ width: "40%", marginBottom: "5px" }}>
                        <Dropdown
                            value={periodo}
                            onChange={(e) => setPeriodo(e.value)}
                            options={periodos}
                            optionLabel="name"
                        />
                    </div>

                    {verRangoDeFechas ? (
                        <div>
                            <Calendar
                                maxDate={today}
                                placeholder="Rango de Fechas"
                                dateFormat="dd/mm/yy"
                                value={dates}
                                selectionMode="range"
                                locale="es"
                                onChange={(e) => setDates(e.value)}
                            />
                        </div>
                    ) : (
                        <SelectButton
                            value={value}
                            onChange={(e) => handleChange(e.value)}
                            optionLabel="name"
                            options={periodosPredifinidos}
                        />
                    )}
                </div>
                <div>
                    <Dp as={Nav.Item}>
                        <Dp.Toggle
                            as={Nav.Link}
                            id="Dp-company-switch"
                            className="buttonHover"
                            onClick={openExportar}
                        >
                            <ToolTip placement="left" message="Exportar">
                                <SvgComponent
                                    iconName="export"
                                    fill={theme.color1}
                                />
                            </ToolTip>
                        </Dp.Toggle>
                    </Dp>
                </div>
            </div>
        );
    };
    const matchModes = [
        { label: 'Menor o igual a', value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
        { label: 'Mayor o igual a', value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
    ];
    const openExportar = () => {
        setShowExportar(true);
    };
    
    useEffect(() => {
        locale('es');
        initFiltros();
    }, []);

    useEffect(() => {
        if (data) {
            let _tiendasFiltradas = [];
            _tiendasFiltradas = data.Resultados.map((e) => {
                return e.text;
            });
            setDataFiltrada(_tiendasFiltradas);
        }
    }, [data]);
    useEffect(() => {
        if(itemsGrid && !errorItemsGrid) {
            setTotalRecords(itemsGrid.total);
            setCargando(false);
            setCargandoGrid(false);
        } else if (itemsGrid) {
            setTotalRecords(itemsGrid.total);
            setCargando(false);
            setCargandoGrid(false);
        }
    }, [itemsGrid]);
    useEffect(() => {
        if (dates) {
            if (dates[0] !== null && dates[1] !== null) {
                setFechas();
            }
        }
    }, [dates]);
    useEffect(() => {
        if (periodo === 1) {
            setPeriodosPredifinidos(actual);
            setVerRangoDeFechas(false);
        } else if (periodo === 2) {
            setPeriodosPredifinidos(anterior);
            setVerRangoDeFechas(false);
        } else {
            setVerRangoDeFechas(true);
        }
    }, [periodo]);
    useEffect(() => {
        setlazyState({
            ...lazyState,
            filters: filtros,
        });
    }, [filtros]);
    useEffect(() => {
        if(errorItemsGrid){
            debugger;
            handleException(errorItemsGrid);
        }
    }, [errorItemsGrid]);
    return (
        <div className='new-p-table'>
            {cargando ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <ProgressSpinner />
                </div>
            ) : (
                <>
                    {showExportar && createPortal(
                        <Exportar
                            PROPIEDADES_EXPORTAR={[
                                {value: 'ItemIdSec', label: 'Id'},
                                {value: 'ItemNombre', label: 'Item'},
                                {value: 'VentaTotalPeriodoActual', label: 'Ventas'},
                                {value: 'Costo', label: 'Costo'},
                                {value: 'Ganancias', label: 'Ganancias'},
                                {value: 'TasaPromedioMargenGanancia', label: 'Promedio de Margen de Ganancias'},
                                {value: 'TasaCrecimientoVenta', label: 'Tasa de Crecimiento de Ventas'},
                                {value: 'PromedioVenta', label: 'Promedio de Ventas'},
                                {value: 'PosiblesVentas', label: 'Posibles Ventas'},
                                {value: 'TasaRelacionCotizacionFactura', label: 'Tasa de Relacion Cotizacion-Factura'}, 
                            ]}
                            where={{...gridWhere.where}}
                            showExportar={showExportar}
                            setShowExportar={setShowExportar}
                            exportarCallBack={exportarRentabilidadGrid}
                        >
                        </Exportar>,
                        window.parent.document.querySelector("#sidebarContainer")
                    )}
                    <DataTable
                        showGridlines
                        header={header}
                        onFilter={onFilter}
                        filters={lazyState.filters}
                        value={itemsGrid.items}
                        lazy
                        first={lazyState.first}
                        rows={25}
                        loading={cargandoData}
                        paginator
                        totalRecords={totalRecords}
                        onPage={onPage}
                        onSort={onSort}
                        sortField={lazyState.sortField}
                        sortOrder={lazyState.sortOrder}
                        tableStyle={{ minWidth: "50rem" }}
                        stripedRows
                        size="small"
                        emptyMessage="No hay resultados disponibles."
                        resizableColumns
                        columnResizeMode="expand"
                        pt={{
                            paginator: { pageButton: 'p-component',nextPageButton: 'p-component', lastPageButton:'p-component', prevPageButton:'p-component', firstPageButton:'p-component' }
                        }}
                    >
                        <Column
                            field="ItemIdSec"
                            sortable
                            header="Id"
                            style={{ textAlign: "right" }}
                        />
                        <Column
                            showFilterMatchModes={false}
                            filter
                            filterField="ItemNombre"
                            filterElement={NombreFiltroTemplate}
                            field="ItemNombre"
                            sortable
                            header="Item"
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                        />
                        <Column
                            filter
                            filterField="VentaTotalPeriodoActual"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="VentaTotalPeriodoActual"
                            sortable
                            header="Ventas"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                            filterPlaceholder="Filtrar por Ventas"
                            body={(rowData) => formatearMoneda(rowData.VentaTotalPeriodoActual)}
                        />
                        <Column
                            filter
                            filterField="Costo"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="Costo"
                            sortable
                            header="Costo"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                            filterPlaceholder="Filtrar por Costo"
                            body={(rowData) => formatearMoneda(rowData.Costo)}
                        />
                        <Column
                            filter
                            filterField="Ganancias"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="Ganancias"
                            sortable
                            header="Ganancias"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                            filterPlaceholder="Filtrar por Ganancias"
                            body={(rowData) => formatearMoneda(rowData.Ganancias)}
                        />
                        <Column
                            filter
                            filterField="TasaPromedioMargenGanancia"
                            filterElement={tasasFiltroTemplate}
                            field="TasaPromedioMargenGanancia"
                            sortable
                            header="Promedio de Margen de Ganancias"
                            style={{ textAlign: "right" }}
                            dataType="numeric"
                            body={(rowData) => formatearTasa(rowData.TasaPromedioMargenGanancia)}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                        />
                        <Column
                            filter
                            filterField="TasaCrecimientoVenta"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="TasaCrecimientoVenta"
                            sortable
                            header="Tasa de Crecimiento de Ventas"
                            style={{ textAlign: "right" }}
                            body={(rowData) => formatearTasa(rowData.TasaCrecimientoVenta)}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                        />
                        <Column
                            filter
                            filterField="PromedioVenta"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="PromedioVenta"
                            sortable
                            body={(rowData) => formatearMoneda(rowData.PromedioVenta)}
                            header="Promedio de Ventas"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                        />
                        <Column
                            filter
                            filterField="PosiblesVentas"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="PosiblesVentas"
                            sortable
                            header="Posibles Ventas"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                            body={(rowData) => formatearMoneda(rowData.PosiblesVentas)}
                        />
                        <Column
                            filter
                            filterField="TasaRelacionCotizacionFactura"
                            filterElement={montoFiltroTemplate}
                            dataType="numeric"
                            field="TasaRelacionCotizacionFactura"
                            sortable
                            header="Tasa de Relacion Cotizacion-Factura"
                            style={{ textAlign: "right" }}
                            showFilterOperator={false}
                            filterMatchModeOptions={matchModes}
                            pt={{
                                filterMenuButton: { className: 'p-component' },
                                filterButtonbar: { className:'test' },
                            }}
                            body={(rowData) => formatearTasa(rowData.TasaRelacionCotizacionFactura)}
                        />
                    </DataTable>
                </>
            )}
        </div>
    );
}